import Cookies from 'js-cookie';

export const AUTH_COOKIE_NAME = 'auth_token';

const SHARED_AUTH_COOKIE_DOMAIN = '.zsdodo.com';
const AUTH_COOKIE_EXPIRES_DAYS = 7;

function getSharedCookieDomain () {
    if (typeof window === 'undefined') {
        return undefined;
    }

    const hostname = window.location.hostname.toLowerCase();

    if (hostname === 'zsdodo.com' || hostname.endsWith('.zsdodo.com')) {
        return SHARED_AUTH_COOKIE_DOMAIN;
    }

    return undefined;
}

function isSharedAuthHost () {
    return Boolean(getSharedCookieDomain());
}

export function getSharedAuthCookieOptions () {
    const domain = getSharedCookieDomain();

    return {
        ...(domain ? { domain } : {}),
        path: '/',
        secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
        sameSite: 'Lax',
        expires: AUTH_COOKIE_EXPIRES_DAYS,
    };
}

export function getSharedAuthCookie () {
    if (!isSharedAuthHost()) {
        return {};
    }

    const value = Cookies.get(AUTH_COOKIE_NAME);

    if (!value) {
        return {};
    }

    try {
        return JSON.parse(value) || {};
    } catch {
        return {};
    }
}

export function setSharedAuthCookie (value) {
    Cookies.set(AUTH_COOKIE_NAME, JSON.stringify(value || {}), getSharedAuthCookieOptions());
}

export function removeSharedAuthCookie () {
    Cookies.remove(AUTH_COOKIE_NAME, { path: '/' });

    const domain = getSharedCookieDomain();
    if (domain) {
        Cookies.remove(AUTH_COOKIE_NAME, { domain, path: '/' });
    }
}

export function hydrateStoreFromSharedAuth (store) {
    if (!isSharedAuthHost()) {
        return false;
    }

    // 如果 store 中已经有有效的 token，则不再用 cookie 覆写，
    // 避免登录流程中 store 已更新（如账号选择后换 token）但 cookie 尚未同步时，
    // 路由跳转触发 beforeEach 将 store 回退为旧的 cookie 值，导致登出死循环。
    if (store.state.user.platformToken) {
        return true;
    }

    const authCookie = getSharedAuthCookie();
    const token = authCookie.token || authCookie.platformToken || '';

    if (!token) {
        return false;
    }

    store.commit('user/setToken', token);

    store.commit('user/setUserData', {
        ...authCookie,
        token,
        platformToken: token,
    });

    const hasAccountData =
        authCookie.accountType !== undefined ||
        authCookie.accountId !== undefined ||
        authCookie.code !== undefined;

    if (hasAccountData) {
        store.commit('user/setAccountData', JSON.stringify({
            accountType: authCookie.accountType,
            accountId: authCookie.accountId,
            id: authCookie.accountId,
            code: authCookie.code,
            token,
        }));
    }

    return true;
}
